import { Button } from 'reactstrap';
import PerformanceChart from './PerformanceChart';
import Spinner from '../../../components/Spinner';
import ContentLoader from '../../../components/ContentLoader';
import CurrencyFormat from 'react-number-format';
import { useDict } from '../../../contexts/LanguageContext';

const ActivityChart = ({
    doStatement,
    graphData,
    annualRate,
    accumulatedReturn,
    isLoading,
}) => {
    const dict = useDict();

    const renderWithLoader = (component) => {
        if (isLoading) {
            return (
                <ContentLoader width="70" height="30" color="loader500">
                    <rect width="100%" height="100%" y="0" rx="5" ry="5" />
                </ContentLoader>
            );
        }
        return component;
    };

    return (
        <>
            <div className="performance__chart" data-cy="performance__chart">
                <h5
                    style={{
                        textAlign: 'center',
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    }}
                    className="title_performance"
                >
                    {dict.profitReturn}
                </h5>
                {isLoading ? (
                    <div className="d-flex justify-content-center">
                        <Spinner />
                    </div>
                ) : (
                    <PerformanceChart graphData={graphData} />
                )}
            </div>

            <div className="performance__summary--mobile">
                <div className="text-center">
                    {renderWithLoader(
                        <h5 className="bold-text" style={{ color: '#ffffff' }}>
                            <span style={{ fontSize: '32px' }}>
                                {parseFloat(annualRate).toFixed(1)}%
                            </span>
                        </h5>
                    )}
                    <h5 style={{ color: '#ffffff', marginTop: '5px' }}>
                        {dict.annualReturn}
                    </h5>
                </div>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: '30px',
                        marginBottom: '15px',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            className="chart-performance-currency-format"
                            value={accumulatedReturn}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                    <h5 style={{ color: '#ffffff', marginTop: '5px' }}>
                        {dict.accumulatedReturn}
                    </h5>
                </div>
                {/* <div className="performance__summary-btn-group">
                    <Button
                        color="gradient-blue"
                        onClick={doStatement}
                        className="icon btn-icon rounded"
                        style={{
                            marginRight: 0,
                            marginBottom: 0,
                        }}
                    >
                        <p
                            style={{ color: '#ffffff' }}
                            className="justify-content-center"
                        >
                            {dict.myStatements}
                        </p>
                    </Button>
                </div> */}
            </div>
        </>
    );
};

export default ActivityChart;
